import { IoClose } from "react-icons/io5";

const MessageModal = ({
  open,
  type = "success", // success | error | info
  title,
  message,
  onClose,
}) => {
  if (!open) return null;

  return (
    <div className="admin-modal-overlay">
      <div className="admin-modal">

        <div className="admin-modal-header">
          <div
            className="admin-modal-title"
            style={{
              color:
                type === "success"
                  ? "#2e7d32"
                  : type === "error"
                  ? "#c62828"
                  : "#005ea2",
            }}
          >
            {title}
          </div>
          <button className="admin-modal-close" onClick={onClose}>
            <IoClose />
          </button>
        </div>

        <div className="admin-form-body">
          <p style={{ fontSize: "14px", color: "#333" }}>
            {message}
          </p>
        </div>

        <div className="admin-form-footer">
          <button className="admin-btn-save" onClick={onClose}>
            OK
          </button>
        </div>

      </div>
    </div>
  );
};

export default MessageModal;
